exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-alerts{padding:20px;display:flex;flex-direction:column}.loadBtn{background:none;border:none}.loadBtn:focus{outline:none}.no-active{display:flex;flex-direction:column;font-size:20px;color:gray;text-align:center;margin:5em}\n", ""]);

